module.exports = __webpack_public_path__ + "static/media/retainer-big.52f6ad04.jpg";